<template>
  <FormItem
    :label="label"
    :value="value"
    :placeholder="placeholder"
    :error="error"
    :type="type || 'text'"
    :page-type="pageType"
    @update:value="emit('update:value', $event)"
  />
</template>

<script lang="ts">
import FormItem from './FormItem.vue';
type Props = {
  label: string;
  value: string;
  placeholder: string;
  error?: string;
  type?: 'text' | 'email';
  pageType: 'PC' | 'H5';
};
const __sfc_main = {};
__sfc_main.props = {
  label: {
    key: "label",
    required: true,
    type: String
  },
  value: {
    key: "value",
    required: true,
    type: String
  },
  placeholder: {
    key: "placeholder",
    required: true,
    type: String
  },
  error: {
    key: "error",
    required: false,
    type: String
  },
  type: {
    key: "type",
    required: false,
    type: String
  },
  pageType: {
    key: "pageType",
    required: true,
    type: String
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const emit = __ctx.emit;
  return {
    emit
  };
};
__sfc_main.components = Object.assign({
  FormItem
}, __sfc_main.components);
export default __sfc_main;
</script>
